<div class="govuk-width-container d-flex">
  <nav class="navbar navbar-expand-lg navbar-light app-masthead">
    <div class="container-fluid nav-container">
      <a class="navbar-brand brand-wordmark" routerLink="/">Cambridgeshire Ceremonies</a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          @for (link of navigation; track link.text) {
          <li class="nav-item">
            <a class="nav-link" [href]="link.url">{{ link.text }}</a>
          </li>
          }
        </ul>
        <div class="d-flex">
          @if (!isAdmin()) {
<button class="btn btn-primary login text-nowrap" (click)="login()">
  Log in
</button>
          }
        </div>
      </div>
    </div>
  </nav>
</div>
